export const HEADER_INDEX: string = 'header';
